const projectCompanyDetailListView = r => require.ensure([], () => r(require('@/page/projectCompanyDetailList/projectCompanyDetailListView')), 'projectCompanyDetailListView');
const projectCompanyDetailList = r => require.ensure([], () => r(require('@/page/projectCompanyDetailList/projectCompanyDetailList')), 'projectCompanyDetailList');


const projectCompanyDetailListRouter = {
    path: '',
    name: '优秀企业推荐',
    component: projectCompanyDetailListView,
    meta: {
        icon: 'expertInfo',
        right: [],
        isShowMenu: true,
        keepAlive:true,
    },
    children: [{
        path: '/projectCompanyDetailList',
        component: projectCompanyDetailList,
        name: '优秀企业推荐',
        meta: {
            right: ['优秀企业推荐'],
            isShowMenu: true,
            keepAlive:true,
        },
    }]
};
export default projectCompanyDetailListRouter;